import { ROLES, BOND_STATUS_LABEL, BOND_STATUS ,BOND_ACTION,BOND_STATUS_VALUE} from "../types";
import moment from 'moment';

export function isBondCounselUser(user) {
  if (!user) {
    return false;
  }
  return user?.userinfo?.role === ROLES.BOND_COUNSEL_USER;
}

export function isOfficeOfTheAttorneyGeneralUser(user) {
  if (!user) {
    return false;
  }
  return user?.userinfo?.role === ROLES.OFFICE_OF_THE_ATTORNEY_GENERAL_USER;
}

export function isBondReviewUser(user) {
  if (!user) {
    return false;
  }
  return user?.userinfo?.role === ROLES.BOND_REVIEW_USER;
}

export function isMacUser(user) {
  if (!user) {
    return false;
  }
  return user?.userinfo?.role === ROLES.MAC_USER;
}

export function isTeaUser(user) {
  if (!user) {
    return false;
  }
  return user?.userinfo?.role === ROLES.TX_EDU_AGENT_USER;
}

export function isTwbUser(user) {
  if (!user) {
    return false;
  }
  return user?.userinfo?.role === ROLES.TX_WATER_DEV_USER;
}

export function isDisabledBasedOnBusinessLogic(user, bonds_data, field_name) {

  if( field_name === "aag_name"){
    console.log(bonds_data['bond_status','bond_status'],field_name,isBondCounselUser(user),user,'user')

  }
  if (bonds_data["bond_status"] === "") {
    bonds_data["bond_status"] = BOND_STATUS_LABEL.Pending;
  }

  if ((field_name=== "legal_assistant" || field_name === "aag_name")&&isBondCounselUser(user)) {
    return true;
  }
  
  if(field_name===BOND_ACTION.DELETE||field_name===BOND_ACTION.UPLOAD){

    if( bonds_data["bond_status"] === BOND_STATUS_LABEL.OpinionComplete||
      bonds_data["bond_status"] === BOND_STATUS_LABEL.RegistrationComplete||
      bonds_data["bond_status"] === BOND_STATUS_LABEL.Delayed||
      bonds_data["bond_status"] === BOND_STATUS_LABEL.Cancelled
    ){
      return true;
    }

  }


  if (bonds_data["bond_status"] === BOND_STATUS_LABEL.OpinionComplete ||
    bonds_data["bond_status"] === BOND_STATUS_LABEL.RegistrationComplete || 
    bonds_data["bond_status"] === BOND_STATUS_LABEL.Cancelled 
  ) {
    return true;
  }

  if (isOfficeOfTheAttorneyGeneralUser(user)) {
    if (
      (
        field_name === "bond_issue_number" ||
        field_name === "fee_amount_due" ||
        field_name === "law_firm"
      ) &&
      bonds_data["bond_status"] === BOND_STATUS_LABEL.OpinionComplete
    ) {
      return true;
    }
  }

  if (isBondCounselUser(user)) {
    if (field_name === "legal_assistant" || field_name === "aag_name") {
      return true;
    }

    // if (bonds_data["bond_status"] === BOND_STATUS_LABEL.TranscriptComplete) {
    //   return true;
    // }

    if (
      field_name === "fee_amount_due" ||
      field_name === "opinion_due_date" ||
      field_name === "law_firm" ||
      field_name === "bond_issue_number" ||
      field_name === "bond_status" ||
      field_name === "submission_date"

    ) {
      return true;
    }
  }

  if (isBondReviewUser(user) || isMacUser(user)) {
    return true;
  }

  return false;
}

export function roleFilteredBondStatus(user) {
  console.log("Test:", BOND_STATUS,BOND_STATUS_LABEL, BOND_STATUS_LABEL);
  if (isBondCounselUser(user)) {
    return BOND_STATUS.filter(
      (status) =>
      status.value === BOND_STATUS_LABEL.New||
      status.value === BOND_STATUS_LABEL.Cancelled||
      status.value === BOND_STATUS_LABEL.Delayed
    );
  }
  if (isOfficeOfTheAttorneyGeneralUser(user)) {
    return BOND_STATUS.filter(
      (status) =>
        status.value === BOND_STATUS_LABEL.New ||
        status.value === BOND_STATUS_LABEL.Pending ||
        status.value === BOND_STATUS_LABEL.OpinionComplete||
        status.value === BOND_STATUS_LABEL.Cancelled ||
        status.value === BOND_STATUS_LABEL.Delayed 
    );
  } else {
    return [];
  }
}

export function is90DaysAfterRegistrationComplete(statusUpdateDate, bondStatus) {


  const formattedTimestamp = statusUpdateDate.replace(/-/g, ' ').replace(/\./g, ':');
  const timestamp = moment(formattedTimestamp, "YYYY MM DD HH mm ss SSSSSS");

  const dateAfter90Days = moment().add(90, 'days');

  return bondStatus === BOND_STATUS_LABEL.RegistrationComplete && timestamp.isAfter(dateAfter90Days);


}
